export default class View {
  constructor(node, ...args) {
    this.$node = $(node);
    [this.node] = this.$node;

    // truthiness, not `!== undefined`: a vue consumer keeps its ref under a v-if and
    // constructs the view unconditionally in onMounted, so a null node must build an
    // uninitialized view instead of running initialize over an empty $node
    if (this.initialize && node) {
      this.initialize(...args);
    }
  }

  on(...args) {
    return this.$node.on(...args);
  }

  off(...args) {
    return this.$node.off(...args);
  }

  trigger(...args) {
    this.$node.trigger(...args);
  }

  $(selector) {
    return $(selector, this.$node);
  }

  html(html) {
    this.$node.html(html);
  }
}
